import { Injectable } from '@angular/core';
import { ImportOrderTransaction } from '@usf/ngrx-order/lib/reducers/import-orders/import-orders.reducer';
import { Customer } from '@usf/customer-types';
import { ImportOrderDownloadDtoService } from '@shared/services/file-download/import-order-download-dto.service';
import { OrderDownloadDtoService } from '@shared/services/file-download/order-download-dto.service';
import { DownloadFileTypes } from '@shared/constants/order-download-file';
import { Product } from '@shared/models/product.model';
import { ProductService } from '@shared/services/product/product.service';
import { filter, take } from 'rxjs';
import { productsAreInState } from '@shared/selectors/helpers/product-info.selectors.helper';
import { FileHandlerBaseService } from '../file-handler/file-handler-base.service';
import { ToastService } from '../toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { SentenceCasePipe } from '@shared/pipes/sentence-case.pipe';
import { LoadingSpinnerService } from '../loading-spinner/loading-spinner.service';
import {
  CONTENT_TYPE_CSV,
  CONTENT_TYPE_CSV_ANDROID,
} from '@shared/constants/files';

@Injectable({
  providedIn: 'root',
})
export class ImportOrderDownloadService extends FileHandlerBaseService {
  constructor(
    private productService: ProductService,
    toastService: ToastService,
    public translateService: TranslateService,
    public platform: Platform,
    public datePipe: DatePipe,
    public sentenceCasePipe: SentenceCasePipe,
    public loadingSpinnerService: LoadingSpinnerService,
  ) {
    super(
      toastService,
      translateService,
      platform,
      datePipe,
      sentenceCasePipe,
      loadingSpinnerService,
    );
  }

  handleDownloadImportOrderValidation(
    fileName: string,
    orders: ImportOrderTransaction[],
    customers: Customer[],
  ) {
    const productNumbersArr = [];
    for (const order of orders) {
      if (order?.orderItems) {
        for (const orderItem of order?.orderItems) {
          productNumbersArr.push(orderItem.productNumber);
        }
      }
    }
    this.productService.loadProducts(productNumbersArr);
    this.productService
      .getProductsWithAlternatives(productNumbersArr)
      .pipe(
        filter(products => productsAreInState(products)),
        take(1),
      )
      .subscribe(products => {
        return this.downloadImportOrderValidationFile(
          orders,
          products,
          fileName,
          customers,
        );
      });
  }

  downloadImportOrderValidationFile(
    orders: ImportOrderTransaction[],
    products: Map<number, Product>,
    fileName: string,
    customers: Customer[],
  ) {
    let fileContents: string;

    const contentType = this.platform.is('android')
      ? CONTENT_TYPE_CSV_ANDROID
      : CONTENT_TYPE_CSV;

    let separatedColumns;
    separatedColumns = ImportOrderDownloadDtoService.createMultipleSeparatedColumnsForImportOrders(
      products,
      orders,
      customers,
    );
    let numberOfRows = separatedColumns[0].columnValues.length;
    // Create the separated values as string
    fileContents = OrderDownloadDtoService.stringifySeparatedValues(
      separatedColumns,
      numberOfRows,
      DownloadFileTypes.CSV.seperator,
    );

    const blob: Blob = new Blob([fileContents], {
      type: contentType,
    });
    return this.downloadFile(
      blob,
      fileName,
      contentType,
      this.platform.is('android'),
    );
  }
}
